import { getMenderDomainUrl } from 'src/constants';

export const getMenderReleasesUrl = (menderSsoGuid: string) =>
  getMenderDomainUrl(menderSsoGuid);
